import { render, staticRenderFns } from "./requestStat.vue?vue&type=template&id=80803046&scoped=true"
import script from "./requestStat.vue?vue&type=script&lang=js"
export * from "./requestStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80803046",
  null
  
)

export default component.exports